import React from "react";
import Spinner from "react-bootstrap/Spinner";
import Button from "react-bootstrap/Button";
import { flattenApi } from "../../api/pages";
import { toast } from "react-toastify";
import "./InsSinglePdf.css";
import InspectPdfModal from "../InspectPdfModal/InspectPdfModal";

class InsSinglePdf extends React.Component {
  constructor(props) {
    super(props);
    this.flattenClicked = this.flattenClicked.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.openModal = this.openModal.bind(this);
    this.pdfImage = React.createRef();
    this.htmlImage = React.createRef();
    this.state = {
      loadedImageUri: null,
      loadedDiffImageUri: null,
      flattening: false,
      showInspectModal: false
    };
  }

  closeModal() {
    this.setState({ showInspectModal: false });
  }

  openModal() {
    const { page } = this.props;

    if (page == null) {
      return;
    }

    const { loadedImageUri, loadedDiffImageUri } = this.state;
    const pageImageUri = `${process.env.REACT_APP_API_ROOT}pages/${
      page.id
    }/page_image`;
    const diffImageUri = `${process.env.REACT_APP_API_ROOT}artworks/${
      page.html_screenshot.id
    }/static`;

    if (
      loadedImageUri !== pageImageUri ||
      loadedDiffImageUri !== diffImageUri
    ) {
      return;
    }

    this.setState({ showInspectModal: true });
  }

  async flattenClicked() {
    this.setState({ flattening: true });

    const { page, handleFlatten } = this.props;
    const pageID = page.id;

    try {
      await flattenApi(pageID);
      handleFlatten(pageID);
    } catch (e) {
      toast.error(e.toString());
    }

    this.setState({ flattening: false });
  }

  componentWillUnmount() {
    if (this.pdfImage.current != null) {
      this.pdfImage.current.src = "";
    }

    if (this.htmlImage.current != null) {
      this.htmlImage.current.src = "";
    }
  }

  render() {
    const { page } = this.props;
    const {
      loadedImageUri,
      loadedDiffImageUri,
      flattening,
      showInspectModal
    } = this.state;

    const isLoading = page == null;
    const pageImageUri = isLoading
      ? null
      : `${process.env.REACT_APP_API_ROOT}pages/${page.id}/page_image`;
    const diffImageUri = isLoading
      ? null
      : `${process.env.REACT_APP_API_ROOT}artworks/${
          page.html_screenshot.id
        }/static`;

    return (
      <div className="inspect_single_pdf_container">
        {(isLoading || loadedImageUri !== pageImageUri) && (
          <div className="inspect_single_pdf_spinner_container">
            <Spinner animation="grow" />
          </div>
        )}
        {!isLoading && (
          <React.Fragment>
            <div
              className="inspect_single_pdf_img_area"
              onClick={this.openModal}
            >
              <img
                style={
                  loadedImageUri === pageImageUri ? {} : { display: "none" }
                }
                className="inspect_pdf_page_image"
                src={pageImageUri}
                alt=""
                ref={this.pdfImage}
                onLoad={() => this.setState({ loadedImageUri: pageImageUri })}
              />
              <img
                style={
                  loadedDiffImageUri === diffImageUri ? {} : { display: "none" }
                }
                className="inspect_diff_page_image"
                ref={el => (this.htmlImage = el)}
                src={diffImageUri}
                alt=""
                onLoad={() =>
                  this.setState({ loadedDiffImageUri: diffImageUri })
                }
              />
            </div>

            <Button
              variant="info"
              disabled={page.should_flatten}
              onClick={this.flattenClicked}
            >
              {flattening ? (
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              ) : (
                `Flatten page ${page.page_num}`
              )}
            </Button>

            <InspectPdfModal
              pageImageUri={pageImageUri}
              diffImageUri={diffImageUri}
              showInspectModal={showInspectModal}
              closeModal={this.closeModal}
              flattenClicked={this.flattenClicked}
              page={page}
            />
          </React.Fragment>
        )}
      </div>
    );
  }
}

export default InsSinglePdf;
